import { FetchierConfig } from '../fetchier/types';
import { recursivelyCoerceKeyValueToQueryParameter } from './recursivelyCoerceKeyValueToQueryParameter';

export const processServerQueryParameters = (params: FetchierConfig['body'] = {}, useDotNotation = false) => {
    if (useDotNotation) {
        // Recursively iterate over params
        return Object.entries(params)
            .map(([key, value]) =>
                recursivelyCoerceKeyValueToQueryParameter(
                    key,
                    value,
                    (keyValue, subKeyValue) => `${keyValue}.${subKeyValue}`
                )
            )
            .join('&');
    }
    return Object.entries(params)
        .map(([key, value]) => recursivelyCoerceKeyValueToQueryParameter(key, value))
        .join('&');
};
